module.exports = __webpack_public_path__ + "img/carousel-2.e352ca25.webp";